import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { WidgetGuard } from 'features/types'
import { AudienceGeoRegionsWidget } from 'schemas/AudienceGeoRegionsWidgetSchema'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { getWidgetForDashboard } from '../../../../features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from '../../../../hooks/useDashboardState'
import { usePageConfigUser } from '../../../../hooks/usePageConfig'
import { createGeoInsightCount } from '../share/utils/createGeoInsightCount'

const RunSearchEffect: WidgetGuard = ({ widgetId, children }) => {
  const widgetSetting = useDashboardWidgetSetting<AudienceGeoRegionsWidget>(widgetId)
  const pageConfigUser = usePageConfigUser()
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const insightCount = createGeoInsightCount(widgetSetting, dashboardData!, pageConfigUser)

    dispatch(
      getWidgetForDashboard({
        widgetId: widgetSetting.widgetId!,
        searches: [insightCount],
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, pageConfigUser, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
